export default __webpack_public_path__ + "static/prop-bg-1-294367bebb0b39519bccf658cb650d02.png";